<template>
  <button class="locale-button" type="button" @click="onClick">
    <img
      class="locale-button__img"
      :src="`${publicPath}img/flags/${locale}.png`"
    />
  </button>
</template>

<script setup lang="ts">
import { ref } from "vue";
import envVars from "@/helpers/Env";
import type { ValidLanguage } from "@/i18n/ValidLanguages";

const props = defineProps<{
  locale: ValidLanguage;
}>();
const emit = defineEmits<{
  (event: "click", locale: ValidLanguage): void;
}>();

const publicPath = ref(envVars.baseUrl ?? "/");

function onClick() {
  emit("click", props.locale);
}
</script>

<style lang="scss">
.locale-button {
  display: block;
  background-color: transparent;
  border: none;
  height: 2em;
  width: 2em;
  overflow: hidden;
  border-radius: 50%;
  padding: 0;

  &:hover {
    transform: scale3d(1.05, 1.05, 1);
    box-shadow: 0 2px 4px -2px var(--color-shadow-1);
  }

  &:focus {
    outline: none;
    box-shadow: 0 2px 6px -2px var(--color-shadow-1);
  }

  &__img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
